import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment-timezone';
import ActionDialog from './action-dialog';
import UserImage from '../user-image/user-image';
import getInitials from '../../helpers/utils';
import store from '../../redux/store';
import Tooltip from '../tooltip/tooltip';
import DynamicTooltip from '../tooltip/dynamic-tooltip';
import {
  // AcceptBorderedIcon,
  AddQuotationIcon,
  CreateBookingIcon,
  CreateShipmentIcon,
} from '../icons/icons';

function NotificationItem({
  item,
  t,
  saveAcceptRejectNotification,
  getTextByCond,
}) {
  const [currentID, setCurrentID] = useState(false);
  const [toggleSelfItem, setToggleSelfItem] = useState(false);
  const hostUrl = `${window.location.protocol}//${window.location.host}`;
  const contentRef = useRef(null);
  const [toggleShowMore, setToggleShowMore] = useState(false);
  const [dataLength, setDataLength] = useState(0);
  const contentContainer = useRef(null);
  const [contentContainerHeight, setContentContainerHeight] = useState(0);

  const toggleSelf = (e) => {
    setCurrentID(e.target.id);
    setToggleSelfItem(true);
  };
  const closeSelf = () => {
    setToggleSelfItem(false);
  };
  useEffect(() => {
    setDataLength(contentRef?.current?.getBoundingClientRect()?.height);
  }, [dataLength]);
  useEffect(() => {
    setContentContainerHeight(
      contentContainer?.current?.getBoundingClientRect()?.height
    );
  }, [contentContainerHeight]);

  const toggleShow = () => {
    setToggleShowMore(!toggleShowMore);
  };

  const transform = (node, index) => {
    if (node?.name === 'a') {
      return (
        <DynamicTooltip
          key={index}
          content={node?.children?.[0]?.data}
          className="tooltip-maxcontent"
        >
          <a className="link" href={node?.attribs?.href}>
            {node?.children?.[0]?.data}
          </a>
        </DynamicTooltip>
      );
    }

    return undefined;
  };

  return (
    <li
      className={`${currentID === item._id ? 'active' : ''}${
        ['general'].includes(item.typeOfNotification) && !item.isRead
          ? ' unread'
          : ''
      }${
        ['milestone'].includes(item.typeOfNotification) && !item.isRead
          ? ' unread'
          : ''
      }${['actionable'].includes(item.typeOfNotification) ? ' unread' : ''}${
        ['approval'].includes(item.typeOfNotification) && !item.isRead
          ? ' unread'
          : ''
      }`}
      role="presentation"
      onClick={toggleSelf}
      id={item._id}
      onKeyUp={toggleSelf}
    >
      <div className="notification-item">
        <span className="time">{item.diff}</span>
        <div className="user-image">
          <UserImage
            path={item.senderOrgLogo}
            shortName={getInitials(item.senderOrgName)}
            size="medium"
          />
        </div>
        <div
          className={`details ${
            item.typeOfNotification !== 'approval' ||
            (item.typeOfNotification !== 'actionable' &&
              item?.action?.value === '')
              ? 'no-action'
              : ''
          }`}
        >
          <p>
            <span className="name">{item.senderOrgName}</span>
          </p>
          <div
            className={`position-relative content ${
              toggleShowMore ? 'visible-all' : ''
            }`}
            ref={contentContainer}
          >
            <p
              ref={contentRef}
              className="position-absolute opacity-0 disable-pointer"
            >
              {ReactHtmlParser(getTextByCond(item.text, item), { transform })}{' '}
              {t('notifications.By')}{' '}
              <span className="name">{item.senderName}</span>{' '}
              {item.changes?.changes?.length > 0 &&
                !(currentID === item._id) && (
                  <span
                    className="id"
                    onClick={toggleSelf}
                    role="presentation"
                    id={item._id}
                  >
                    +{item.changes?.changes?.length} {t('notifications.More')}{' '}
                    {item.changes?.changes?.length > 1
                      ? t('notifications.updates')
                      : t('notifications.update')}
                  </span>
                )}
            </p>
            <p>
              {ReactHtmlParser(getTextByCond(item.text, item), { transform })}{' '}
              {t('notifications.By')}{' '}
              <span className="name">{item.senderName}</span>{' '}
              {item.changes?.changes?.length > 0 &&
                !(currentID === item._id) && (
                  <span
                    className="id"
                    onClick={toggleSelf}
                    role="presentation"
                    id={item._id}
                  >
                    +{item.changes?.changes?.length} {t('notifications.More')}{' '}
                    {item.changes?.changes?.length > 1
                      ? t('notifications.updates')
                      : t('notifications.update')}
                  </span>
                )}
            </p>
          </div>
          {dataLength > contentContainerHeight ? (
            <button type="button" className="show-more" onClick={toggleShow}>
              {toggleShowMore
                ? t('notifications.showLess')
                : t('notifications.showMore')}
            </button>
          ) : (
            ''
          )}
          {item?.changes?.reason && currentID === item._id && (
            <p>
              {t('notifications.reason')}
              {': '}
              {item?.changes?.reason}
            </p>
          )}
        </div>
        {item.typeOfNotification === 'approval' && (
          <ActionDialog
            type={item.type}
            acceptYesClick={() =>
              saveAcceptRejectNotification(
                'Accepted',
                item.itemIds,
                item.relationId,
                item.type
              )
            }
            t={t}
            rejectYesClick={() =>
              saveAcceptRejectNotification(
                'Rejected',
                item.itemIds,
                item.relationId,
                item.type
              )
            }
          />
        )}
        {item.typeOfNotification === 'actionable' &&
          item?.action?.value !== '' && (
            <div className="action">
              <a href={`${hostUrl}/${item.link}?popover=${item.action.value}`}>
                {item?.action?.value === 'Add Booking' && (
                  <Tooltip content={item?.action?.key} direction="bottom">
                    <CreateBookingIcon />
                  </Tooltip>
                )}
                {item?.action?.value === 'Create Shipment' && (
                  <Tooltip content={item?.action?.key} direction="bottom">
                    <CreateShipmentIcon />
                  </Tooltip>
                )}
                {item?.action?.value === 'Add Quotation' && (
                  <Tooltip content={item?.action?.key} direction="bottom">
                    <AddQuotationIcon />
                  </Tooltip>
                )}
                {/* {item?.action?.value.toLowerCase() === 'acknowledge' && (
                  <Tooltip
                    content={`${item?.action?.key
                      .charAt(0)
                      .toUpperCase()}${item?.action?.key
                      .slice(1)
                      .toLowerCase()}`}
                    direction="bottom"
                  >
                    <AcceptBorderedIcon />
                  </Tooltip>
                )} */}
              </a>
            </div>
          )}
      </div>
      {/* Childs */}
      {item.changes?.changes?.length > 0 &&
        currentID === item._id &&
        item?.changes?.changes?.map((ele) => {
          let prevData;
          let upData;
          let content;
          if (!ele?.changes) {
            prevData = ele.previousData;
            upData = ele.updatedData;

            if (ele.parameter.match(/date/gi)) {
              const userTimeZone =
                store.getState().omniProfile.profileDetail?.fetchProfileDetails
                  ?.data?.timezone;
              prevData = moment
                .tz(ele.previousData, userTimeZone)
                .format('DD/MM/YYYY');
              upData = moment
                .tz(ele.updatedData, userTimeZone)
                .format('DD/MM/YYYY');
            }

            content = `${item.text}
                                    <span className="text-capitalize">
                                    ${t(`notifications.${ele.parameter}`)}
                                    </span>
                                    <strong>${prevData}</strong> ${t(
              'notifications.to'
            )}
                                    <strong>${upData}</strong>`;
          }
          if (ele?.changes) {
            const desc = [];
            ele.changes.forEach((descEle) => {
              prevData = descEle.previousData;
              upData = descEle.updatedData;

              if (descEle.parameter.match(/date/gi)) {
                const userTimeZone =
                  store.getState().omniProfile.profileDetail
                    ?.fetchProfileDetails?.data?.timezone;
                prevData = moment
                  .tz(descEle.previousData, userTimeZone)
                  .format('DD/MM/YYYY');
                upData = moment
                  .tz(descEle.updatedData, userTimeZone)
                  .format('DD/MM/YYYY');
              }

              desc.push(`<span className="text-capitalize">
                                ${t(`notifications.${descEle.parameter}`)} ${t(
                'notifications.ChangeRequested'
              )} ${t('notifications.from')}
                              </span>
                              <strong>${prevData}</strong> ${t(
                'notifications.to'
              )}
                              <strong>${upData}</strong>`);
            });
            content = [...desc];
          }

          return (
            <div
              className={
                (item.isRead
                  ? 'notification-item'
                  : 'notification-item unread') ||
                ([
                  'notification-item actionable',
                  ' notification-itemapproval',
                ].includes(item.typeOfNotification)
                  ? 'notification-item unread'
                  : '')
              }
            >
              {/* <span className="time">{item.diff}</span> */}
              <div className="user-image">
                <UserImage
                  path={item.senderOrgLogo}
                  shortName={getInitials(item.senderOrgName)}
                  size="medium"
                />
              </div>
              <div className="details">
                <p>
                  <span className="name">
                    <a className="link" href={`${hostUrl}/${item.link}`}>
                      {ele?.itemCode ? (
                        <>#{ele.itemCode}</>
                      ) : (
                        item?.relationNo && item.relationNo
                      )}
                    </a>
                    {ele?.itemCode && (
                      <span> {t('notifications.ChangeRequested')}</span>
                    )}
                  </span>
                  <p>{ReactHtmlParser(content)}</p>
                </p>
              </div>
            </div>
          );
        })}
      {item?.changes?.changes && currentID === item._id && toggleSelfItem && (
        <button type="button" className="show-less" onClick={closeSelf}>
          {t('notifications.seeLess')}
        </button>
      )}
    </li>
  );
}

export default NotificationItem;
NotificationItem.propTypes = {
  item: PropTypes.arrayOf(Object),
  t: PropTypes.func,
  saveAcceptRejectNotification: PropTypes.func,
  getTextByCond: PropTypes.func,
};
NotificationItem.defaultProps = {
  item: {},
  t: () => {},
  saveAcceptRejectNotification: () => {},
  getTextByCond: () => {},
};
